import React from 'react';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
// import Button from 'react-bootstrap/Button';
import classes from './AppointmentBox.css'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { ButtonLink } from '../UI/TextLink/TextLink';
import { beautifyLocalTimeFromTimestamp } from '../../store/utility';

class AppointmentBox extends React.Component{

    render(){

        // let infoRows = (this.props.isMobile) ? 6 : 5;

        // figure whether this is a host / guest appointment, and what name to show
        let role;
        let firstName;
        let lastName;
        let email;
        if (this.props.role === 'host'){
            role = <Badge variant="info">guest</Badge>
            if (this.props.guest != null){
                firstName = this.props.guest.first_name;
                lastName = this.props.guest.last_name;
                email = this.props.guest.email;
            }
            else {
                firstName = this.props.firstName;
                lastName = this.props.lastName;
                email = this.props.email;
            }
        }
        else {
            role =  <Badge variant="info">host</Badge>
            firstName = this.props.host.first_name;
            lastName = this.props.host.last_name;
            email = this.props.host.email;
        }        

        return (

        <Card bsPrefix={classes.Box}>
            <Card.Body>

                <Card.Text>
                    { beautifyLocalTimeFromTimestamp(this.props.time) }
                </Card.Text>

                <Card.Text className={classes.Name}>
                    <b>{firstName} {lastName}</b> {role}
                    <br></br>
                    {email}
                    <br></br>
                    {/* { contact_method ? contact_method : null } */}
                </Card.Text>

                {/* <Card.Text>
                    {this.props.info}
                </Card.Text> */}

                <Card.Text>
                    <ButtonLink 
                        size='sm'
                        link={'/appointment-management/'+ this.props.appointment_id} 
                        text="Manage" 
                        icon={faExternalLinkAlt}>
                    </ButtonLink>
                </Card.Text>

            </Card.Body>
        </Card>
        );
    }
}

export default AppointmentBox;


// WEBPACK FOOTER //
// ./src/components/AppointmentBox/AppointmentBox.js